// One read, and the four outcomes this area already has a vocabulary for.
//
// WHY THIS IS SHARED AND NOTHING ELSE IS
// ======================================
// Priorities and Follow-ups are different screens showing different things,
// and they are deliberately NOT abstracted into one component. What they do
// share is the load: the same `get()` helper, the same ok/disabled/denied/error
// vocabulary from `./api`, and the same need to render nothing fabricated while
// the request is in flight. That much is identical, so it lives once.
//
// `status` starts "loading" rather than defaulting to an empty result. A
// surface that renders "nothing needs you" before the read has returned is
// telling the owner something it does not yet know.
import { useEffect, useState } from "react";

import { get } from "./api";

export default function usePanelData(path) {
  const [res, setRes] = useState({ status: "loading", data: null });

  useEffect(() => {
    let alive = true;
    setRes({ status: "loading", data: null });
    (async () => {
      const out = await get(path);
      if (alive) setRes(out);
    })();
    return () => {
      alive = false;
    };
  }, [path]);

  return res;
}
